<template>
  <div
    ckass="ma-0 pa-0"
    style="width: 100%; height: 100%"
    v-resize:debounce="recalcWidthHeight"
    :class="isOnMobile ? 'box-container' : 'box-container-horizontal'"
  >
    <!-- <v-row class="ma-4 mr-10 pa-0" style="height: 80px; min-height: 80px" align="center" justify="center"> -->
    <loading-component v-if="!loaded" style="width: 100%" :text="'Намерени локации: ' + counter + ' от ' + stations.length"> </loading-component>
    <error-component
      v-else-if="datatype && datatype.errorMessage"
      :text="datatype.errorMessage"
      align="center"
      justify="center"
      class="row-header ma-0 pa-0"
      style="width: 100%"
    >
    </error-component>
    <!-- </v-row> -->
    <!-- <v-row
      v-else
      class="ma-0 pa-0"
      :class="isOnMobile ? 'box-container' : 'box-container-horizontal'"
      :style="isOnMobile ? 'flex-direction: column-reverse;' : ''"
    > -->
    <div v-else class="row-header ma-0 pa-0" ref="refDeviceList">
      <station-list
        v-model="lastStation"
        class="ma-0 pa-1"
        :items="getStations"
        :width="isOnMobile ? '100%' : 220"
        :height="isOnMobile ? 300 : '100%'"
        @filterChanged="filterChanged"
        @stationClick="(station) => showPopUp(station)"
      >
      </station-list>
    </div>
    <div class="ma-0 pa-0 row-content" ref="refContainer">
      <div class="box-container ma-0 pa-0" :style="`width: ${mapWidth}; height: ${mapHeight}; position: relative`">
        <!--<v-card
          style="z-index: 99999; position: absolute; top: 10px; bottom: auto; right: auto; left: 60px; width: 160px"
          :style="isWithSmallWidth ? 'width: 120px; left: 190px' : ''"
          class="ma-0 pa-0"
        >
          <v-select
            class="ma-0 pa-0"
            hide-details
            v-if="loaded"
            outlined
            v-model="devsFilterType"
            :items="devsFilterTypes"
            item-text="name"
            dense
            @change="refreshData"
            label="Станции"
          ></v-select>
        </v-card> -->

        <v-card v-if="editable" class="ma-0 pa-0" :style="'z-index: 999; position: absolute; bottom: 10px; left: 20px; top: auto; right: auto;'">
          <t-btn :class="'ma-0 pa-2'" :small="true" @click="changeEditMode(true)">
            <span>{{ editLocation ? "Запис" : "Редакция на местоположението" }}</span>
            <v-icon>{{ editLocation ? "mdi-checkbox-marked-circle-outline" : "mdi-pencil" }}</v-icon>
          </t-btn>
        </v-card>

        <v-card v-if="editable" class="ma-0 pa-0" :style="'z-index: 999; position: absolute; bottom: 10px; left: 150px; top: auto; right: auto;'">
          <t-btn v-if="editLocation" :class="'ma-0 pa-2'" :small="true" @click="changeEditMode(false)">
            <span>Отказ</span>
            <v-icon>mdi-minus-circle</v-icon>
          </t-btn>
        </v-card>

        <!-- <v-text-field v-if="loaded" light class="ma-0 pa-0 py-1" style="z-index: 99999;  position: absolute; top: 10px; bottom: auto; right: auto; left: 230px; width: 160px;" :style="isWithSmallWidth ? 'width: 120px;' : ''" background-color="#fff" label="Търсене на ФУ" outlined v-model="devsSearch" dense @input="refreshData" @keyup.enter="showPopUp(getItems[0])"></v-text-field> -->
        <!-- <t-button :light="true" :small="true" :btnIcon="'mdi-pencil'" :style="'z-index: 9999; background-color: #fff; position: absolute; bottom: 10px; left: 300px; top: auto; right: auto;'" :btnText="'Маршрут'" @click.native="addRoute()"></t-button> -->
        <!-- <v-lazy class="ma-0 pa-0" style="overflow: hidden" :width="mapWidth" :height="mapHeight"> -->
        <!-- <l-map ref="refDeviceMap" @update:zoom="redrawMap" @leaflet:load="mapLoaded" :zoom="currentZoom" :center="currentCenter" :minZoom="currentMinZoom" :maxBounds="currentMaxBounds" :options="mapOptions" @update:center="centerUpdate" :style="(isInDarkMode?'background-color: #fff;':'background-color: #000;')+ 'position: relative; height: ' + mapHeight + '; width: ' + mapWidth">
            <l-tile-layer :url="isInDarkMode?'https://tiles.stadiamaps.com/tiles/alidade_smooth_dark/{z}/{x}/{y}{r}.png':'http://{s}.tile.osm.org/{z}/{x}/{y}.png'"></l-tile-layer>-->
        <l-map
          ref="refDeviceMap"
          @update:zoom="redrawMap"
          @ready="mapLoaded"
          v-model:zoom="currentZoom"
          :center="currentCenter"
          :minZoom="currentMinZoom"
          :maxBounds="currentMaxBounds"
          :options="mapOptions"
          @update:center="centerUpdate"
        >
          <!-- <l-tile-layer v-if="isInDarkMode" url="https://tiles.stadiamaps.com/tiles/alidade_smooth_dark/{z}/{x}/{y}{r}.png" attribution='&copy; <a href="https://stadiamaps.com/">Stadia Maps</a>, &copy; <a href="https://openmaptiles.org/">OpenMapTiles</a> &copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors'></l-tile-layer> -->
          <l-tile-layer style="z-index: -2" layer-type="base" v-if="isLayerVisible" :url="mapUrl" :attribution="mapAttribution"></l-tile-layer>
          <l-marker
            ref="reflastStationMarker"
            class="ma-0 pa-0"
            v-if="lastStation && lastStation.location && lastStation.ImageUrl"
            :lat-lng="lastStation.location"
            :icon="icons[lastStation.ImageUrl]"
          >
            <l-popup
              style="margin: 0; padding: 0"
              class="ma-0 pa-0"
              :class="ChargeStationStatusGetString(lastStation.Status)"
              :options="{ minWidth: '280', direction: 'top', offset: { x: 0, y: -15 } }"
            >
              <v-row class="ma-0 pa-0" justify="center">
                <span style="font-size: 15px">{{ lastStation.name + ", " + lastStation.Power + "Kw" }}</span>
              </v-row>
              <v-divider class="ma-2 pa-0"></v-divider>
              <v-row class="ma-0 pa-0 box-container-horizontal" justify="space-around" style="overflow: hidden !important">
                <div v-if="lastStation.Image" class="row-header" style="overflow: hidden !important">
                  <v-img :src="lastStation.Image" :width="60" :height="80"></v-img>
                </div>

                <v-col v-if="lastStation.onlineConnectors" class="row-content" align="center" justify="space-around">
                  <v-row cols="12" class="ma-0 pa-0" v-for="(c, ix) in lastStation.onlineConnectors" :key="ix" align="center">
                    {{ c.Type }}
                    <v-icon :size="26" :color="c.IconColor">{{ c.Icon }}</v-icon>
                    {{ c.lastFDDisplayStatus }}
                  </v-row>
                </v-col>
              </v-row>
              <v-divider class="ma-1 pa-0"></v-divider>
              <v-row class="ma-0 pa-0">
                <span>{{ "Адрес: " + lastStation.Address }}</span>
              </v-row>
              <v-row class="ma-0 pa-0">
                <a @click="showModalMap(lastStation.Address)" style="cursor: pointer">Покажи в Google Maps</a>
              </v-row>
            </l-popup>
          </l-marker>
          <l-marker
            ref="refcurrentStationMarker"
            v-if="currentStation"
            :draggable="editLocation"
            @dragenter="lastDevDragStart"
            @dragstart="lastDevDragStart"
            @dragend="lastDevDragEnd"
            @drag="lastDevDrag"
            class="ma-0 pa-0"
            style="z-index: 999"
            :lat-lng="currentStation.location"
            :icon="true ? icons[currentStation.ImageUrl] : transparentIcon"
            @click="showPopUp(currentStation)"
          >
            <l-tooltip class="ma-0 pa-0" :options="{ interactive: true, direction: 'top', offset: { x: 0, y: -30 } }">
              <v-row class="ma-0 pa-1">
                <v-row class="ma-0 pa-0">
                  <span>{{ "Име: " + currentStation.name }}</span>
                </v-row>
                <v-row class="ma-0 pa-0">
                  <span>{{ "Мощност: " + currentStation.Power + "Kw" }}</span>
                </v-row>
                <v-row class="ma-0 pa-0">
                  <span>{{ "Статус: " + ChargeStationStatusGetString(currentStation.Status) }}</span>
                </v-row>
                <v-row class="ma-0 pa-0" v-if="currentStation.onlineConnectors">
                  <span>{{
                    "Конектори: " +
                    Object.values(currentStation.onlineConnectors)
                      .map((c) => c.Type)
                      .join(", ")
                  }}</span>
                </v-row>
              </v-row>
            </l-tooltip>
          </l-marker>
        </l-map>
      </div>
      <!-- </v-lazy> -->
    </div>
  </div>
</template>
<script>
import L, { latLng, latLngBounds } from "leaflet";
import { LMap, LTileLayer, LTooltip, LPopup, LMarker } from "@vue-leaflet/vue-leaflet";
import ChargeStationStatus, { getString } from "@/js/ChargeStationStatus";
import DataManager from "@/data/DataManager";

// import "leaflet-canvas-marker";
import "leaflet/dist/leaflet.css";
// require("../../../node_modules/leaflet/dist/leaflet.css");
// require("../../../node_modules/leaflet-routing-machine/dist/leaflet-routing-machine.js");
// require("../../../node_modules/leaflet-routing-machine/dist/leaflet-routing-machine.css");

require("@/js/leaflet.canvas-markers");

import { EsriProvider } from "leaflet-geosearch";
import { ref } from "vue";
import { g_Dialog } from "@/main";
import HTTPSender from "@/js/HTTPSender";
const provider = new EsriProvider();

// import { OpenStreetMapProvider } from 'leaflet-geosearch';
// const provider = new OpenStreetMapProvider();

// FIX leaflet's default icon path problems with webpack
// delete L.Icon.Default.prototype._getIconUrl;
// L.Icon.Default.mergeOptions({
//   iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
//   iconUrl: require("leaflet/dist/images/marker-icon.png"),
//   shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
// });

const imageGreen = require("@/assets/green_background2.png");
const imageTransparent = require("@/assets/transparent_icon.png");

export default {
  name: "leaflet-map",
  components: {
    LMap,
    LTileLayer,
    LTooltip,
    LPopup,
    LMarker,
    // LLayerGroup
    // StackedCards,
  },
  props: {
    editable: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      stations: [],
      datatype: null,
      title: "",

      isLayerVisible: true,
      ChargeStationStatus: ChargeStationStatus,
      ChargeStationStatusGetString: getString,
      onfocus: false,
      // zoom: 7.2,
      // center: latLng(42.7902107,25.4090009),
      markers: {},
      counter: 0,
      loaded: true,
      currentStation: null,
      lastStation: null,
      editLocation: false,
      movingLatLng: null,
      currentZoom: 7.2,
      currentMinZoom: 6.5,
      currentCenter: latLng(42.7902107, 25.4090009),
      currentMaxBounds: latLngBounds([44.405133, 22.093418], [41.361333, 28.602028]),
      mapOptions: {
        zoomSnap: 0.2,
        preferCanvas: true,
        drawControl: false,
      },

      filteredItems: undefined,
      icons: {},

      buttonsHeight: 33,
      mapHeight: "500px",
      mapWidth: "500px",
      timeoutRecalcSize: null,
      devsFilterTypes: [
        { id: 0, name: "Всички станции" },
        { id: 1, name: "Офлайн" },
      ],
      devsFilterType: "Всички станции",
      devsSortTypes: [
        { id: 0, name: "Име", prop: "name" },
        { id: 1, name: "Model", prop: "model" },
        { id: 2, name: "Адрес", prop: "Address" },
      ],
      devsSortType: "Име",
      devsSearch: null,
      ciLayer: null,
      iconObject: {
        shadowUrl: imageGreen,
        iconSize: [20, 30],
        iconAnchor: [10, 30],
        shadowSize: [30, 40],
        shadowAnchor: [15, 32],
        tooltipAnchor: [0, 0],
        popupAnchor: [0, 0],
      },
      greenIcon: L.icon({
        iconUrl: imageGreen,
        ...this.iconObject,
      }),
      transparentIcon: L.icon({
        iconUrl: imageTransparent,
        ...this.iconObject,
      }),
    };
  },
  methods: {
    setFocus(on) {
      this.onfocus = on;
    },
    /**
     * @param {DataManager.DataType} datatype
     * @param {ErrorMessage} error
     */
    setMeta(meta, err) {
      this.datatype = meta.datatype;
      this.title = this.isOnMobile ? meta.title : meta.description;

      if (err.success && !err.message) {
        this.refreshData();
        // this.datatype.isLoading = false;
      } else {
        this.datatype.errorMessage = err.message;
        this.datatype.isLoading = false;
      }
    },
    refreshData() {
      if (this.loaded) {
        this.loaded = false;
        this.currentStation = null;
        this.lastStation = null;
        this.counter = 0;
        this.stations = [];
        this.$nextTick(async () => {
          this.stations = DataManager.getData(this.datatype, true);

          //var filterIdx = this.devsFilterTypes.findIndex(f => f.name == this.devsFilterType);

          Object.values(this.markers).forEach((mm) => {
            if (this.$refs.refDeviceMap) this.$refs.refDeviceMap.leafletObject.removeMarker(mm, true);
          });

          this.markers = {};
          var itemsWoAddress = this.getItems.filter((i) => !i.location || !(i.location instanceof Object));
          this.counter = this.getItems.length - itemsWoAddress.length;
          await itemsWoAddress
            .asyncForEach(async (item) => {
              if (item.Address) {
                await provider.search({ query: item.Address }).then((result) => {
                  if (result.length > 0) {
                    this.updateCP(item, { lat: result[0].y, lng: result[0].x });
                  }
                });
              }
              this.counter++;
              return this.counter;
            })
            .then(async () => {
              this.getItems
                .asyncForEach((i) => {
                  if (!this.icons[i.ImageUrl]) {
                    this.icons[i.ImageUrl] = L.icon({
                      iconUrl: i.Image,
                      ...this.iconObject,
                    });
                  }

                  //if (filterIdx == 0 && (!this.devsSearch || i.name.contains(this.devsSearch) || i.id.contains(this.devsSearch))) {
                  if (i.location) {
                    if (this.$refs.refDeviceMap) {
                      this.markers[i.id] = L.marker(i.location, {
                        customid: i.id,
                        icon: this.icons[i.ImageUrl],
                      })
                        .addTo(this.$refs.refDeviceMap.leafletObject)
                        .on("mouseover", () => {
                          this.currentStation = i;
                          // var markerLatLng = ev.latlng; //ev.target._latlng;??
                          // console.log(ev);
                          // console.log(markerLatLng);
                          // var dev = this.stations.find((f) => f.location && f.location.lat == markerLatLng.lat && location.lng == markerLatLng.lng);
                          // if (dev) {
                          //   this.currentStation = dev;
                          //   console.log("currentStation = " + this.currentStation.name);
                          // }
                        });
                    }
                  }
                  //}
                })
                .then(() => {
                  this.loaded = true;
                  if (Object.keys(this.markers).length > 0) {
                    this.$nextTick(() => {
                      this.redrawMap();
                    });
                  }
                });
            });
        });
      }
    },
    updateCP(cp, location) {
      HTTPSender.SendPOSTreq(
        JSON.stringify({
          chargePointId: cp.id,
          location: JSON.stringify(location),
        }),
        "Command/UpdateCP"
      );
      // .done((res) => {
      // })
      // .fail((err) => {
      // });
    },

    // addRoute() {
    //   L.Routing.control({
    //     waypoints: this.stations.map((i) => i.location),
    //     router: new L.Routing.osrmv1({
    //       language: "ru",
    //       profile: "car",
    //     }),
    //     //geocoder: L.Control.Geocoder.nominatim({}),
    //   }).addTo(this.$refs.refDeviceMap.leafletObject);
    // },
    mapLoaded() {
      this.recalcWidthHeight().then(() => {
        this.redrawMap();
      });
    },
    changeEditMode(save) {
      if (this.editLocation) {
        if (save) {
          this.stations.forEach((s) => {
            if (s._isDirty) {
              this.updateCP(s.id, s.location);
              s._isDirty = false;
            }
          });

          // TODO mass update all cps
          // HTTPSender.SendPOSTreq(
          //   JSON.stringify({
          //     chargePointId: this.currentStation.id,
          //     settings1: JSON.stringify({ ...this.currentStation.settings1 }),
          //   }),
          //   "Command/UpdateCP"
          // )
          //   .done((res) => {
          //     g_Dialog.close();
          //     if (res.success) {
          //       g_Dialog.showInfo("Успешна операция.");
          //     } else {
          //       g_Dialog.showError("Грешка при редакция на местоположение за станцията!\n" + res.status);
          //     }
          //   })
          //   .fail((err) => {
          //     g_Dialog.close();
          //     console.log("fail");
          //     console.log(JSON.stringify(err));
          //   });
        } else {
          DataManager.loadData(this.datatype, () => {
            this.refreshData();
          });
        }
        this.editLocation = false;
        this.movingLatLng = null;
      } else {
        this.editLocation = true;
        this.currentStation = this.lastStation;
        this.lastStation = null;
        g_Dialog.showInfo("Кликнете върху картинката на станцията, задръжте бутона и преместете мишката, за да промените местоположението и.");
      }
    },
    lastDevDrag(e) {
      if (this.currentStation) {
        this.currentStation.location = e.target.getLatLng();
        this.markers[this.currentStation.id].setLatLng([this.currentStation.location.lat, this.currentStation.location.lng]);
        // this.ciLayer.redraw();
      }
      this.$forceUpdate();
    },
    lastDevDragStart() {
      // this.ciLayer.setOpacity(0);
    },
    lastDevDragEnd() {
      if (this.currentStation) {
        this.currentStation._isDirty = true;
        //this.lastStation = this.currentStation;
        this.currentStation = null;
      }
      this.$nextTick(() => {
        // this.ciLayer.setOpacity(1);
        this.$forceUpdate();
      });
    },

    zoomUpdate(zoom) {
      this.currentZoom = zoom;
    },
    centerUpdate(center) {
      this.currentCenter = center;
    },
    showPopUp(item) {
      if (!this.editLocation) {
        this.currentStation = null;
        this.lastStation = item;
      } else {
        this.lastStation = null;
      }

      //this.markers.forEach(m => m.setOpacity(0));
      this.$nextTick(() => {
        if (item && item.location) {
          this.$refs.refDeviceMap.leafletObject.once("moveend", () => {
            this.$nextTick(() => {
              // this.ciLayer.setOpacity(1);
              if (this.$refs.reflastStationMarker) {
                this.$refs.reflastStationMarker.leafletObject.openPopup();
              }
            });
          });
          // this.ciLayer.setOpacity(0);
          this.$refs.refDeviceMap.leafletObject.flyTo(item.location, 15);
          // this.stations.forEach(i => {
          //   this.$refs["marker" + i.sn + "ref"][0].leafletObject.setZIndexOffset(0);
          // });
          // this.$refs["marker" + item.sn + "ref"][0].leafletObject.setZIndexOffset(this.stations.length - 1);
        }
      });
    },
    showModalMap(devaddress) {
      g_Dialog.show(g_Dialog.dialog_types.google_map, null, {
        address: devaddress,
      });
    },
    async recalcWidthHeight() {
      new Promise((resolve) => {
        if (this.timeoutRecalcSize) clearTimeout(this.timeoutRecalcSize);
        this.timeoutRecalcSize = setTimeout(() => {
          if (this.$refs && this.$refs.refContainer) {
            this.mapHeight = this.$refs.refContainer.clientHeight + "px";
            this.mapWidth = this.$refs.refContainer.clientWidth - "px";
            this.$nextTick(() => {
              this.redrawMap();
              resolve();
            });
          }
        }, 1000);
      });
    },
    redrawMap() {
      if (this.$refs.refDeviceMap && this.$refs.refDeviceMap.leafletObject) {
        this.$refs.refDeviceMap.leafletObject.invalidateSize();
      }
    },
    filterChanged(filtered) {
      this.filteredItems = filtered;
    },
  },
  computed: {
    mapUrl() {
      return "http://{s}.tile.osm.org/{z}/{x}/{y}.png";
      // return this.isInDarkMode ? "https://tiles.stadiamaps.com/tiles/alidade_smooth_dark/{z}/{x}/{y}{r}.png" : "http://{s}.tile.osm.org/{z}/{x}/{y}.png";
      // ? "https://tiles.stadiamaps.com/tiles/alidade_smooth_dark/{z}/{x}/{y}{r}.png"
      // : "https://tiles.stadiamaps.com/tiles/outdoors/{z}/{x}/{y}{r}.png"; //mapUrl:,
    },
    mapAttribution() {
      return '&copy; <a href="https://openmaptiles.org/">OpenMapTiles</a> &copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors';
      // return this.isInDarkMode
      //   ? '&copy; <a href="https://stadiamaps.com/">Stadia Maps</a>, &copy; <a href="https://openmaptiles.org/">OpenMapTiles</a> &copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors'
      //   : '&copy; <a href="https://openmaptiles.org/">OpenMapTiles</a> &copy; <a href="http://openstreetmap.org">OpenStreetMap</a> contributors';
      //return '&copy; <a href="https://www.stadiamaps.com/" target="_blank">Stadia Maps</a> &copy; <a href="https://openmaptiles.org/" target="_blank">OpenMapTiles</a> &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors';
    },
    getStations() {
      if (!this.datatype) return [];
      return DataManager.getData(DataManager.data.ChargeStation) ?? [];
      // var filterIdx = this.devsFilterTypes.findIndex((f) => f.name == this.devsFilterType);
      // return this.stations.filter((i, idx) => filterIdx == idx);
    },

    getItems() {
      if (!this.datatype) return [];
      return DataManager.getData(DataManager.data.ChargeStation) ?? [];
      // var filterIdx = this.devsFilterTypes.findIndex((f) => f.name == this.devsFilterType);
      // return (this.filteredItems == undefined ? this.stations : this.filteredItems).filter((i) => filterIdx == 0 || (i.IsFuvas && i.IsBlocked));
      // var prop = this.devsSortTypes.find(st => st.name == this.devsSortType).prop;
      // return this.stations.filter(i => (filterIdx == 0 || (i.IsFuvas && i.IsBlocked)) && (!this.devsSearch || i.Name.contains(this.devsSearch) || i.sn.contains(this.devsSearch))).sort((a, b) => a[prop].localeCompare(b[prop], "bg", { sensitivity: "base" }));
    },
  },
  watch: {
    isBannerVisible() {
      this.recalcWidthHeight();
    },
    isInDarkMode() {
      this.isLayerVisible = false;
      this.$nextTick(() => {
        this.isLayerVisible = true;
      });
    },
  },
  mounted() {
    this.recalcWidthHeight();
  },
  setup() {
    const refContainer = ref(null);
    const refDeviceMap = ref(null);
    const reflastStationMarker = ref(null);
    const refDeviceList = ref(null);

    // onMounted(() => {
    //   console.log("on mounted");
    //   console.log(refGrid.value);
    // });
    return { refContainer, refDeviceMap, reflastStationMarker, refDeviceList };
  },
};
</script>

<style>
.v-theme--dark.v-application .leaflet-map {
  background-color: #222;
}

.v-theme--dark.v-application .leaflet-tile,
.v-theme--dark.leaflet-layer,
.v-theme--dark.leaflet-popup,
.v-theme--dark.leaflet-control-zoom-in,
.v-theme--dark.leaflet-control-zoom-out,
.v-theme--dark.leaflet-control-attribution {
  filter: brightness(0.7) invert(1) contrast(3) hue-rotate(200deg) saturate(0.3) brightness(0.6) !important;
  /* filter: invert(100%) hue-rotate(180deg) brightness(95%) contrast(90%) !important; */
}

.v-theme--dark.v-application .leaflet-popup-content-wrapper {
  border: 1px solid white;
}
.v-theme--dark .leaflet-popup-content-wrapper,
.v-theme--dark .leaflet-tooltip {
  background-color: #222;
  color: white;
}
</style>